export const iconListFront = [
  "devicon-javascript-plain colored", 
  "devicon-react-original-wordmark colored",
  "devicon-html5-plain-wordmark colored",
  "devicon-css3-plain-wordmark colored",
  "devicon-sass-original colored",
]

export const iconListBack = [
  "devicon-nodejs-plain-wordmark colored",
  "devicon-express-original-wordmark colored",
  "devicon-python-plain-wordmark colored",
  "devicon-django-plain-wordmark colored",
  "devicon-mongodb-plain-wordmark colored",
  "devicon-postgresql-plain-wordmark colored",
  "devicon-github-plain-wordmark colored",
  "devicon-heroku-original-wordmark colored"
]

